<div class="nav-side-menu">
  <div class="brand d-md-none">Menú</div>
  <i class="fa fa-bars fa-2x toggle-btn" data-toggle="collapse" data-target="#menu-content"></i>
  <div class="menu-list">
   
    <ul id="menu-content" class="menu-content collapse out">
      <li (click)="addNewTab(0,null)">
        <a href="javascript:void(0)">
          <i class="fa fa-home fa-lg"></i> Inicio
        </a>
      </li>
      <li data-toggle="collapse" data-target="#mantenimiento" class="collapsed">
        <a href="javascript:void(0)">
          <i class="fa fa-file fa-lg"></i> Mantenimiento
          <span class="arrow"></span>
        </a>
      </li>
      <ul class="sub-menu collapse" id="mantenimiento">
        <li *ngIf="emp_in_rol_type=='3'" (click)="addNewTab(1,null)">Alumno</li>
        <li *ngIf="emp_in_rol_type=='3'" (click)="addNewTab(2,null)">Profesor y Administrador</li>
        <li *ngIf="emp_in_rol_type=='2'" (click)="addNewTab(3,null)">Cursos</li>
        
        <li *ngIf="emp_in_rol_type=='3'" (click)="addNewTab(6,null)">Encuesta</li>
      </ul>
     
      <li data-toggle="collapse" data-target="#Configuracion" class="collapsed" *ngIf="emp_in_rol_type=='3'">
        <a href="javascript:void(0)">
          <i class="fa fa-file fa-lg"></i> Configuracion
          <span class="arrow"></span>
        </a>
      </li>
      <ul class="sub-menu collapse" id="Configuracion" *ngIf="emp_in_rol_type=='3'">
        <ng-container *ngFor="let parameter of parameters">
          <li *ngIf="parameter.sys_in_group==0" (click)="addNewTab(4,parameter)">{{parameter.sys_vc_description}}</li>
        </ng-container>
      </ul>

    

      <li data-toggle="collapse" data-target="#Reporte" class="collapsed">
        <a href="javascript:void(0)"><i class="fa fa-file fa-lg"></i> Reporte<span class="arrow"></span></a>
      </li>
      <ul class="sub-menu collapse" id="Reporte">

      </ul>
    </ul>
  </div>
</div>